import {createSelectionSlice} from 'entities/monitor';

const httpMonitor = createSelectionSlice('httpMonitor', ({httpMonitorReducer}) => httpMonitorReducer);

export default httpMonitor.reducer;
export const {toggleOne, selectAllOnPage, clearAll} = httpMonitor.actions;

export const httpMonitorSelectedIdsSelector = httpMonitor.selectedIdsSelector;
export const isSelectedAllSelector = httpMonitor.isSelectedAllSelector;
